import { ReferenceCategoryEntity, ReferenceEntity } from '../../';
import { ProductSubcategoryEntity, ProductLocationTypeEntity } from 'src/modules/products';
import { CountryEntity, CountryLocalizedEntity } from 'src/store/types';
import { LocationTypeLocalizedEntity } from 'src/modules/locationTypes';

export enum ProfessionalsReferencesListingActions {
  FetchListingBegin = 'PROFESSIONALS/REFERENCES/LISTING/FETCH/BEGIN',
  FetchListingSuccess = 'PROFESSIONALS/REFERENCES/LISTING/FETCH/SUCCESS',
  FetchListingError = 'PROFESSIONALS/REFERENCES/LISTING/FETCH/ERROR',
  FetchFiltersBegin = 'PROFESSIONALS/REFERENCES/LISTING/FILTERS/FETCH/BEGIN',
  FetchFiltersSuccess = 'PROFESSIONALS/REFERENCES/LISTING/FILTERS/FETCH/SUCCESS',
  FetchFiltersError = 'PROFESSIONALS/REFERENCES/LISTING/FILTERS/FETCH/ERROR',
  FetchCountBegin = 'PROFESSIONALS/REFERENCES/LISTING/COUNT/FETCH/BEGIN',
  FetchCountSuccess = 'PROFESSIONALS/REFERENCES/LISTING/COUNT/FETCH/SUCCESS',
  FetchCountError = 'PROFESSIONALS/REFERENCES/LISTING/COUNT/FETCH/ERROR',
  // SetCategoryFilter = 'PROFESSIONALS/REFERENCES/LISTING/SET_CATEGORY_FILTER',
  // SetRegionFilter = 'PROFESSIONALS/REFERENCES/LISTING/SET_REGION_FILTER',
  // SetRoomFilter = 'PROFESSIONALS/REFERENCES/LISTING/SET_ROOM_FILTER',
  SetFilters = 'PROFESSIONALS/REFERENCES/LISTING/SET_FILTERS',
  SeeMoreReferences = 'PROFESSIONALS/REFERENCES/LISTING/SEE_MORE_REFERENCES',
}

// export const referencesPerPage = 14; //14
// export const filteredReferencesPerPage = 1; //12
export const referencesToLoad = 12; //6

export interface ProfessionalsReferencesListingStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  errorFilters: any;
  isLoadingFilters: boolean;
  isLoadedFilters: boolean;
  errorCount: any;
  isLoadingCount: boolean;
  isLoadedCount: boolean;
  references: ReferenceEntity[];
  referencesCount: number;
  pagination: number;
  referenceCategories: ReferenceCategoryEntity[];
  locationTypes: LocationTypeLocalizedEntity[];
  countries: CountryLocalizedEntity[];
  filters: {
    referenceCategories: ProductSubcategoryEntity[];
    countries: CountryEntity[];
    locationTypes: ProductLocationTypeEntity[];
  };
}
